import React from 'react';
import { Box } from '@mui/material';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      className="tab-panel-animated"
      hidden={value !== index}
      id={`content-tabpanel-${index}`}
      aria-labelledby={`content-tab-${index}`}
      {...other}
      sx={{ pt: 2.5 }}
    >
      {value === index && children}
    </Box>
  );
}

export default TabPanel;